import React from 'react'

export const Controls = (props) => {
  const {
    startScreenShare,
    startCamera,
    isConnected,
    isSharing,
    stopScreenShare,
    leaveRoom,
  } = props;
  return (
    <div className='controls'>
      <button
        onClick={startScreenShare}
        disabled={!isConnected || isSharing}
        className='btn btn-primary'
      >
        Start Screen Share
      </button>
      <button
        onClick={startCamera}
        disabled={!isConnected || isSharing}
        className='btn btn-primary'
      >
        Start Camera
      </button>
      <button
        onClick={stopScreenShare}
        disabled={!isSharing}
        className='btn btn-secondary'
      >
        Stop Screen Share
      </button>
      <button onClick={leaveRoom} className='btn btn-warning'>
        Leave Room
      </button>
    </div>
  );
};
